// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-321da524] .el-table th > .cell {\n  font-size: 12px;\n  font-weight: 400;\n}\n[data-v-321da524] .el-table th {\n  padding: 10px 0;\n  line-height: 16px;\n}\n[data-v-321da524] .el-table .cell {\n  font-size: 12px;\n  font-weight: 400;\n}\n[data-v-321da524] .el-table .cell span {\n    font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
